import(/* webpackMode: "eager" */ "/workspace/app/academics/[school]/components/Products.jsx")